/**
 * BlogPostFeaturedMedia — the detail-page hero media for a blog post.
 *
 * Renders the editorial featured image when present + loadable; falls
 * back to the on-brand gradient cover when there is no image OR the
 * image fails to load (e.g. a not-yet-deployed absolute URL). Extracted
 * as its own component so the image-error state lives in a stable hook
 * (BlogPostPage renders this conditionally and cannot host the hook).
 *
 * @module @puffin-core/marketing-shell/blog/BlogPostFeaturedMedia
 */

import { useState } from 'react';
import PropTypes from 'prop-types';

export default function BlogPostFeaturedMedia({ src, title }) {
  const [failed, setFailed] = useState(false);
  if (src && !failed) {
    return (
      <img
        className="post-featured-image"
        src={src}
        alt=""
        itemProp="image"
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <span className="post-featured-cover" aria-hidden="true">
      <span className="post-featured-cover-mark">{title?.charAt(0) || 'P'}</span>
    </span>
  );
}

BlogPostFeaturedMedia.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string,
};
